import React from "react";
import Newsletter from "./Newsletter";
import ContactInfo from "./ContactInfo";
import FooterLinks from "./FooterLinks";
import { useEffect, useState } from "react";

import  HomeAPI  from "../../api/homeApi";



const Footer = () => {

    const [SettingData, setSettingData] = useState(null);
    useEffect(() => {
      const fetchData = async () => {
        try {
          const data = await HomeAPI.getSettingData();
  
          setSettingData(data);
  
        } catch (error) {
          console.error("Error fetching home data:", error);
        }
      };
  
      fetchData();
    }, []);
  
  
  return (
    <div className="footer-container flex flex-col  gap-[32px] sm:gap-[64px] w-full px-4 sm:px-[144px] pt-[32px] sm:pt-[64px] pb-[20px] sm:pb-[40px] items-center bg-[#E5F2E8] mx-auto">
      {/* Contact Info and Newsletter */}
      <div className="flex items-start flex-col sm:flex-row w-full max-w-[1152px] justify-between max-sm:items-center gap-[32px] sm:gap-0 ">
        <ContactInfo SettingData={SettingData}/>
        <Newsletter SettingData={SettingData}/>
      </div>

      {/* Footer Links */}
      <FooterLinks />
    </div>
  );
};

export default Footer;
